module.exports = __webpack_public_path__ + "static/img/xeo-logo.1bbc72e3.png";